// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"37d7c0b0","444":"04377bd2","626":"01773521","864":"5c5b7d64","870":"5364e471"}[chunkId] + ".chunk.js";
};